import Vue from "vue";
import Vuex from "vuex";
import brands from "./brands_store/store";

Vue.use(Vuex);

// Last Homepage ID Used: 174

export default new Vuex.Store({
  modules: {
    brands
  },
  state: {
    previewIds: null,
    logo: "",
    chosenBrand: 'None',
    chosenComponents: [],
    componentTypes: [
      {
        type: 'hero',
        heading: "Heroes",
        explanation: "Hero components are one of the first things a user sees when they arrive at your site. This area should be visually interesting, set the tone, and include one or a few call-to-action links to encourage the user to explore your site. Including a hero component above the fold on your site is highly recommended."
      },
      {
        type: "quicklinks",
        heading: "Quicklinks",
        explanation: "While we love a great looking homepage, ultimately we want to direct users quickly to the vehicles or services they're interested in. By providing easy ways to immediately send users to more specific pages, quicklinks can be helpful components you may want to include on your homepage multiple times. You can even place a compact link component above the hero for extra navigation help!"
      },
      {
        type: "filter",
        heading: "Filters",
        explanation: "Filter components help direct users to their specific needs within your site. Whether you use links to specific vehicles or services, a search bar, a make/model/trim filter, or all three, these are great ways to help your user find what they're looking for faster."
      },
      {
        type: "vehicles",
        heading: "Vehicles",
        explanation: "Vehicle components use model images to show off your inventory as well as link the user directly to search results displaying each model they might choose. For more visual users, this is a helpful filter as well as a good way to display your brand's full catalog."
      },
      {
        type: "content",
        heading: "Content",
        explanation: "Additional information about either your brand or your dealership can give a more personal touch and show the user more reasons why you are the right choice to help them with their automotive needs."
      },
      {
        type: "services",
        heading: "Services",
        explanation: "Many dealerships have more departments than just the sales team. Showing your online resources regarding financing, trade-ins, service and parts departments, collision departments, and more helps users know more about the scope of your dealership services."
      },
      {
        type: "banner",
        heading: "Banners",
        explanation: "Sokal provides it's clients with beautiful, custom banners to help advertise your special deals or services. These components cycle through any of these you'd like to display."
      },
      {
        type: "contact",
        heading: "Contact",
        explanation: "Ultimately, you'll want the vistors to your website to be vistors to your store. A component that gives quick access to your location, phone numbers, or hours can be a great way to help them get there."
      }
    ],
    navComponentTypes: [
      {
        type: "navbar",
        heading: "Main Navigation Menu",
        explanation: "The navigation menu is an important part of your website as it is present on every page and is the primary way for a user to access content across the site. You want your navbar to hit upon the main resources a user might be looking for while also keeping it from being too cluttered or overfull."
      },
      {
        type: "subnav",
        heading: "Subnavs and Extras",
        explanation: "We want to keep the main navigation menu easy to read and that can mean pushing other important content down to a subnav bar. While these components are not required, depending on your navigation menu choice, you may want to include additional navigation options as well."
      }
    ],
    footerComponentTypes: [
      {
        type: "pre-foot",
        heading: "Extras",
        explanation: "These items will also appear on every page usually offering helpful links or contact information. Position them right above the main footer component for best effect."
      },
      {
        type: "footer",
        heading: "Footers",
        explanation: "Footer components are much like navigation components in that they will be present on all pages across your site. They allow your users to navigate from one page or another, access your sitemap, and see final links and contact information. All sites should include one footer."
      }
    ],
    navComponents: [
      {
        type: "navbar", 
        id: 167,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/nav-components/nav-right-with-contact-toolbar-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/nav-components/nav-right-with-contact-toolbar-ford.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/nav-components/nav-right-with-contact-toolbar-infiniti.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/nav-components/nav-right-with-contact-toolbar-hyundai.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Nav Right With Contact V Extended Toolbar",
        exclusive: [],
        packages: [],
        exclude_from: [],
        newer: false,
        priority: 0
      },
      // {
      //   type: "navbar", 
      //   id: 0,
      //   previews: [
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/nav-components/centered-logo-nav-toyota.png'),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Centered Logo Nav",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: "navbar", 
      //   id: 1,
      //   previews: [
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/nav-components/default-fixed-top-nav-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/nav-components/default-nav-subnav-toyota.png'),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Default Fixed Top Navigation and Default Subnavigation",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: "navbar", 
      //   id: 2,
      //   previews: [
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/nav-components/dg-navigation-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/nav-components/dg-nav-below-nav-toyota.png'),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "DG Navigation and DG Below Navigation",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      {
        type: "navbar", 
        id: 3,
        previews: [
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/nav-components/header-nav-below-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-kia.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-mazda.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-nissan.png'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/nav-components/header-navigation-below-toyota.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Header with Navigation Below",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Kia", "Infiniti"],
        newer: false
      },
      {
        type: "navbar", 
        id: 4,
        previews: [
          {
            brands: ["None"],
            image: require("../static/images/nav-right-expand-search2.png"),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-kia.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-mazda.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi", "CJDR"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-nissan.png'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/nav-components/nav-right-expand-search-toyota.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Nav Right Expand Search",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Kia", "Infiniti"],
        newer: false
      },
      {
        type: "navbar", 
        id: 11,
        previews: [
          {
            brands: ["None"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-default.png"),
            primary: true
          },
          {
            brands: ["None"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-hyundai-expanded.jpg"),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-chevy.png"),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/nav-components/nav-right-with-contact-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-ford.png"),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-honda.png"),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-hyundai.png"),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-infiniti.png"),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-white-kia.png"),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-lincoln.png"),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-mitsu.png"),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-nissan.png"),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-toyota.png"),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Nav Right With Contact White",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: "navbar", 
        id: 13,
        previews: [
          {
            brands: ["None", "CJDR", "Mitsubishi", "Toyota"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-red.png"),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-chevy.png"),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-ford.png"),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-honda.png"),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-hyundai.png"),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-infiniti.png"),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-kia-dark02.png"),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-lincoln.png"),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require("../static/images/nav-right-expand-search-v2.png"),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require("../static/images/component-previews/nav-components/nav-right-with-contact-black-nissan.png"),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Nav Right With Contact Black",
        exclusive: [],
        packages: [],
        exclude_from: [],
        newer: true
      },
      // {
      //   type: "navbar", 
      //   id: 5,
      //   previews: [
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/nav-components/nav-right-search-below-toyota.png'),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Nav Right Search Below",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: "navbar", 
      //   id: 6,
      //   previews: [
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/nav-components/search-header-nav-below-toyota.png'),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Search Header Nav Below",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: "navbar", 
      //   id: 7,
      //   previews: [
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/nav-components/search-header-with-nav-toyota.png'),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Search Header with Nav",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      {
        type: "navbar", 
        id: 8,
        previews: [
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-kia.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-mazda.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-nissan.png'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/nav-components/transparent-nav-right-toyota.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Transparent Nav Right",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Kia", "Infiniti"],
        newer: false
      },
      // {
      //   type: "subnav", 
      //   id: 9,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require("../static/images/contact-toolbar-dark.png"),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Contact Toolbar Dark",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      {
        type: "subnav", 
        id: 10,
        previews: [
          {
            brands: ["None"],
            image: require("../static/images/search-bar.png"),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Search Bar",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Kia", "Infiniti"],
        newer: false
      },
      {
        type: "subnav", 
        id: 12,
        previews: [
          {
            brands: ["None"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-default.png"),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-chevy.png"),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-cjdr.png"),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-ford.png"),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-honda.png"),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-hyundai.png"),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-infiniti.png"),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-kia.png"),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-lincoln.png"),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-mazda.png"),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-mitsu.png"),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-nissan.png"),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require("../static/images/component-previews/nav-components/sub-nav-links-toyota.png"),
            primary: false
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Sub Nav Links",
        exclusive: [],
        packages: [],
        exclude_from: ["Kia"],
        newer: true
      }
    ],
    bodyComponents: [
      {
        type: ["hero"],
        id: 168,
        previews: [
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/browse-filter-any-field-overflow-hero-ford.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/browse-filter-any-field-overflow-hero-infiniti.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/browse-filter-any-field-overflow-hero-hyundai.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Browse Filter Any Field Overflow Hero",
        description: "This component is able to use either an image or video background. The text headings and CTA's can shown or hidden to create a different look.",
        exclusive: ["Infiniti", "Ford", "Hyundai"],
        packages: [],
        exclude_from: [],
        newer: true,
        priority: 0,
      },
      {
        type: ["hero"],
        id: 165,
        previews: [
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-kia.jpg'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-ford.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-honda.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-toyota.jpg'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-chevy.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-infiniti.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-mitsu.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-cjdr.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Background Video Slider",
        description: "This component can show multiple carousel slides with different image or video backgrounds, different text, and different CTA buttons. The slideshow functionality will disappear if you only want one slide or are waiting to add more slides as new offers at your dealership become available, etc.",
        exclusive: [],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      // {
      //   type: ["hero"],
      //   id: 100,
      //   previews: [
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/browse-vehicles-background-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/browse-vehicles-background-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/browse-vehicles-background-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/browse-vehicles-background-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-toyota.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-background-cjdr.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/browse-vehicles-background-ford.gif'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Browse Vehicles Background",
      //   description: "This component is able to use either an image or video background. The buttons are customizable and can be plain text buttons or image buttons. The button images are completely customizable by our art department.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["hero"],
      //   id: 101,
      //   previews: [
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-infiniti.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/browse-vehicles-search-hero-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-cjdr.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/browse-vehicles-search-hero-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/browse-vehicles-search-hero-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/browse-vehicles-search-hero-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/browse-vehicles-search-hero-toyota-02.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-hero-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-search-background-mistu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/browse-vehicles-search-hero-toyota-02.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/browse-vehicles-search-hero.gif'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Browse Vehicles Search Hero",
      //   description: "This component is able to use either an image or video background. The search bar, filter, and buttons can all be showing or we can hide one or two of them to get a different look.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["contact"],
        id: 102,
        previews: [
          {
            brands: ["None", "Toyota", "Nissan", "Mitsubishi", "CJDR"],
            image: require('../static/images/component-previews/body-conmponents/contact-info-row-red.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/contact-info-row-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford", "Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/contact-info-row-navy.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/contact-info-row-honda.png'),
            primary: false
          },
          {
            brands: ["Infiniti", "Kia", "Mazda", "Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/contact-info-row-black.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Contact Info Row",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["contact"],
        id: 103,
        previews: [
          {
            brands: ["None", "Toyota", "Nissan", "Mitsubishi", "CJDR"],
            image: require('../static/images/component-previews/body-conmponents/contact-row-red.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/contact-row-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford", "Hyundai", "Infiniti", "Kia", "Mazda", "Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/contact-info-row-white.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/contact-row-honda.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Contact Row",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      // {
      //   type: ["quicklinks"],
      //   id: 104,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/default-browse-vehicles-with-images.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-images-mazda.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Default Browse Vehicles with Images",
      //   description: "The button images are completely customizable by our art department.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["quicklinks"],
      //   id: 105,
      //   previews: [
      //     {
      //       brands: ["None", "Ford", "Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-ford.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Toyota", "Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-red.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/default-browse-vehicles-nissan.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Default Browse Vehicles",
      //   description: "Button colors are customizable. Amount of buttons is typically three or four. Verbiage above buttons is also customizable and optional.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["quicklinks"],
        id: 106,
        previews: [
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-infiniti.png'),
            primary: false
          },
          {
            brands: ["None", "Toyota", "Nissan", "Mitsubishi", "CJDR"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-cjdr.png'),
            primary: true
          },
          {
            brands: ["Chevrolet", "Ford", "Hyundai", "Honda", "Kia", "Mazda", "Lincoln"],
            image: require('../static/images/quicklinks-row.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Interaction Bar",
        description: "A row of icons where each one links out to a popular page on the website. Can be scrolled horizontally via navigational arrows (desktop) or by swiping (mobile).",
        exclusive: [],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["quicklinks"],
        id: 107,
        previews: [
          {
            brands: ["None", "Toyota", "Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-search-toyota.png'),
            primary: true
          },
          {
            brands: ["CJDR", "Infiniti", "Kia", "Mazda", "Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-search-kia.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-search-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-search-honda.png'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-search-chevy.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-search-hyundai.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-search-nissan.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Interaction Bar with Search",
        description: "A row of icons and search bar where each one links out to a popular page on the website. Can be scrolled horizontally via navigational arrows (desktop) or by swiping (mobile).",
        exclusive: [],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      // {
      //   type: ["filter"],
      //   id: 108,
      //   previews: [
      //     {
      //       brands: ["None", "Toyota", "Nissan", "Mitsubishi", "CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-tabs-red.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-three-tabs-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford", "Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-three-tabs-navy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-three-tabs-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda", "Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/browse-vehicles-three-tabs-black.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Browse Vehicles Three Tabs",
      //   description: "All images and options are customizable.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["content"],
        id: 109,
        previews: [
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-chevy.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-ford.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-honda.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-infiniti.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-kia.jpg'),
            primary: true
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-mitsu.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/content-with-img-links-toyota.jpg'),
            primary: false
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Content with Image and Links",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      },
      {
        type: ["vehicles"],
        id: 110,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-toyota.jpg'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-ford.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-honda.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-infiniti.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-kia.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-chevy.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-mitsu.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Default Featured Vehicles",
        description: "This component pulls from the inventory and will respond to user behavior by showing vehicles similar to what individual users have been looking for.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["vehicles"],
        id: 110,
        previews: [
          // {
          //   brands: ["Toyota"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-toyota.jpg'),
          //   primary: true
          // },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicles-v2-ford.png'),
            primary: false
          },
          // {
          //   brands: ["Honda"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-honda.jpg'),
          //   primary: false
          // },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicles-v2-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/featured-vehicles-v2-infiniti.png'),
            primary: false
          },
          // {
          //   brands: ["Kia"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-kia.jpg'),
          //   primary: false
          // },
          // {
          //   brands: ["Nissan"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-nissan.jpg'),
          //   primary: false
          // },
          // {
          //   brands: ["Chevrolet"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-chevy.jpg'),
          //   primary: false
          // },
          // {
          //   brands: ["CJDR"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-cjdr.jpg'),
          //   primary: false
          // },
          // {
          //   brands: ["Lincoln"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-lincoln.jpg'),
          //   primary: false
          // },
          // {
          //   brands: ["Mitsubishi"],
          //   image: require('../static/images/component-previews/body-conmponents/featured-vehicle-row-23-mitsu.jpg'),
          //   primary: false
          // }
        ],
        mobilePreview: "",
        body: "",
        title: "Default Featured Vehicles v2",
        description: "This component pulls from the inventory and will respond to user behavior by showing vehicles similar to what individual users have been looking for.",
        exclusive: ["Infiniti", "Ford", "Hyundai"],
        packages: [],
        exclude_from: [],
        newer: false
      },
      // {
      //   type: ["contact"],
      //   id: 111,
      //   previews: [
      //     {
      //       brands: ["None", "Toyota", "Nissan", "Mitsubishi", "CJDR"],
      //       image: require('../static/images/default-google-map.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/default-google-maps-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford", "Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/default-google-map-navy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/default-google-maps-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/default-google-maps-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/default-google-maps-lincoln.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Default Google Map",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["content"],
      //   id: 112,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/default-homepage-reviews-black.png'),
      //       primary: true
      //     },
      //     {
      //       brands:[ "None"],
      //       image: require('../static/images/default-homepage-reviews-white.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Default Homepage Reviews",
      //   description: "This component is a carousel that cycles through reviews. Which reviews get displayed is up to you.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["banner"],
        id: 113,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/default-homepage-banner.jpg'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/banners/chevy/CM-JN-24-Chevy-Lifestyle.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/banners/cjdr/CM-MC-26-CJDR-Modern.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/banners/ford/CM-MR-26-Ford-Playful.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/banners/honda/CM-SL-24-Honda-Modern.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/banners/hyundai/CM-JN-24-Hyundai-Playful.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/banners/infiniti/CM-AB-24-INFINITI-Established.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/banners/kia/CM-PW-24-Kia-Established.jpg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/banners/lincoln/CM-SL-CA-Lincoln-Playful.jpg'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/banners/mazda/CM-KT-24-Mazda-Established.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/banners/mitsubishi/CM-EC-26-Mitsubishi-Established.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/banners/nissan/CM-DJ-26-Nissan-Established.jpg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/banners/toyota/CM-MS-24-Toyota-Modern.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Default Homepage Banner",
        description: "All banners are made by our art department. This component is a carousel that cycles through whichever banners you want displayed on the homepage in whichever order you choose.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      // {
      //   type: ["filter"],
      //   id: 114,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/delux-vehicle-filter.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-search-filter-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicles-filter-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-cjdr.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Deluxe Vehicle Filter",
      //   description: "Colors are customizable and buttons listed under Browse the Site are up to you.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["hero"],
      //   id: 115,
      //   previews: [
      //     {
      //       brands: ["None", "Nissan"],
      //       image: require('../static/images/deluxe-vehicle-filter-welcome-background.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-filter-welcome-background-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicles-filter-welcome-background-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-vehicle-filter-welcome-background-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/deluxe-filter-welcome-background-cjdr.jpg'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Deluxe Vehicle Filter Welcome Background",
      //   description: "Colors are customizable and buttons listed under Browse the Site are up to you.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Kia", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["quicklinks"],
      //   id: 116,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/dg-browse-vehicles-default.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Toyota", "Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/dg-browse-vehicles-red.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/DG-browse-vehicles-default-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford", "Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/dg-browse-vehicles-default-navy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/dg-browse-vehicles-default-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/dg-browse-vehicles-default-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/dg-browse-vehicles-default-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/dg-browse-vehicles-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/dg-browse-vehicles-default-cjdr.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "DG Browse Vehicles Default",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["content"],
        id: 117,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/component-previews/body-conmponents/dg-youtube-playlist-all.png'),
            primary: true
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/dg-youtube-playlist-white.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "DG Youtube Playlist",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: false
      },
      // {
      //   type: ["hero"],
      //   id: 118,
      //   previews: [
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-mitsubishi.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-cjdr.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/double-image-hero-toyota.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Double Image Hero",
      //   description: "This component accepts different background images or videos and displays any verbiage or deal you want to highlight.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["filter"],
      //   id: 119,
      //   previews: [
      //     {
      //       brands: ["None", "Toyota", "Mitsubishi"],
      //       image: require('../static/images/dropdown-search.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-search-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-search-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-search-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-search-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-search-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-filter-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-search-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/dropdown-search-nissan.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Dropdown Search",
      //   description: "Verbiage above filter is optional and customizable.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["hero"],
      //   id: 120,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/filter-welcome-background.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-cjdr.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/filter-welcome-background-mitsu.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Filter Welcome Background",
      //   description: "This component is able to use either an image or video background. A headline title above the filter is optional and customizable.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["services"],
        id: 121,
        previews: [
          {
            brands: ["None", "Toyota"],
            image: require('../static/images/finance-application-display.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-display-mazda.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-nissan.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/finance-application-mitsu.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Finance Application Display",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["vehicles", "content"],
        id: 122,
        previews: [
          {
            brands: ["Ford"],
            image: require('../static/images/ford-commercial-vehicle-display.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Ford Commercial Vehicle Display",
        description: "",
        exclusive: ["Ford"],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["contact"],
        id: 123,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/get-directions.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Get Directions",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["hero"],
        id: 124,
        previews: [
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-mazda-24.jpg'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-chevy-24.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-cjdr-24.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-ford-24.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-honda-24.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-hyundai-24.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-infiniti-24.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-kia-24.jpg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-lincoln-24.jpg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-toyota-24.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-nissan-24.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/hero-banners-dropdown-search-mitsu-24.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Hero Banners with Dropdown Search",
        description: "This component is a carousel of homepage banners with an overlapping dropdown search filter.",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: true
      },
      // {
      //   type: ["hero"],
      //   id: 125,
      //   previews: [
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-filter-toyota.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-cjdr.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/hero-dropdown-search-mitsu.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Hero Dropdown Search",
      //   description: "This component is able to use either an image or video background. The headline above the filter is optional and customizable.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["banner"],
        id: 126,
        previews: [
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-mazda.jpg'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-chevy.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-ford.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-honda.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-infiniti.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-kia.jpg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-mitsu.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/homepage-banners-mazda-compliant-toyota.jpg'),
            primary: false
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Homepage Banners with Margins",
        description: "All banners are made by our art department. This component is a carousel that cycles through whichever banners you want displayed on the homepage in whichever order you choose. It has additional padding around it that keeps it from being flush with other components or the sides of the browser.",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: false
      },
      {
        type: ["content"],
        id: 127,
        previews: [
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-chevy.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-ford.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-honda.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-infiniti.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-kia.jpg'),
            primary: true
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-mitsu.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-image-toyota.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Homepage Content over Image",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      },
      {
        type: ["quicklinks"],
        id: 128,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-default.jpg'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-chevy.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-ford.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-honda.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-infiniti.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-kia.jpg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-mitsu.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-toyota.jpg'),
            primary: false
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Homepage Quick Links",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      },
      {
        type: ["quicklinks"],
        id: 166,
        previews: [
          {
            brands: ["Toyota", "None"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-toyota.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/homepage-quick-links-boxes-arrows-nissan.png'),
            primary: false
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Homepage Quick Link Boxes with Arrows",
        description: "The quick link boxes change color and grow on hover.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["banner"],
        id: 129,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/homepage-strip-banner-default.jpg'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/banners/chevy/SOKAL-SRS-Chevy-120921-DealerDraft-Modern.jpeg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Established.jpeg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Lifestyle.jpeg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/banners/honda/SOKAL-SRS-120921-Clarity-Established.jpeg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/banners/hyundai/SOKAL-SRS-120921-Tucson-Modern.jpeg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/banners/infiniti/SOKAL-SRS-112921-DealerDraft-Infinity-4Playful.jpeg'),
            primary: false
          },
          {
            brands:[ "Kia"],
            image: require('../static/images/banners/kia/SOKAL-SRS-112921-Telluride-Lifestyle.jpeg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/banners/lincoln/SOKAL-SRS-121021-Aviator-Lifestyle.jpeg'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/banners/mazda/SOKAL-SRS-112321-DealerDraftMazda-Lifestyle1.jpeg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/banners/mitsubishi/SOKAL-SRS-121021-Eclipse-Modern.jpeg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/banners/nissan/SOKAL-SRS-112321-Pathfinder-Modern.jpeg'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/banners/toyota/Sokal-Toyota-SRS-112221-Modern.jpeg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Homepage Strip Banners",
        description: "All banners are made by our art department. This component is a carousel that cycles through whichever banners you want displayed on the homepage in whichever order you choose.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      // {
      //   type: ["services"],
      //   id: 130,
      //   previews: [
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/image-collection-sliding-overlays.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-cjdr.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/image-collection-sliding-overlays-mitsu.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Image Collection Sliding Overlays",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["hero"],
      //   id: 131,
      //   previews: [
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-kia.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-cjdr.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-toyota-23.jpg'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/interactive-hero-slider-mitsu.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Interactive Hero Slider",
      //   description: "This component is an image slideshow with a box that slides down for each image who's content is completely customizable.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["content"],
        id: 132,
        previews: [
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/mazda-5050-preview.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Mazda 50-50 Content",
        description: "",
        exclusive: ["Mazda"],
        packages: [],
        exclude_from: [],
        newer: false
      },
      // {
      //   type: "contact",
      //   id: 133,
      //   previews: [
      //     {
      //       brands: ["None", "Toyota", "Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-red.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford", "Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-navy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/map-hours-table-cjdr.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Map and Hours Table",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: "contact",
        id: 134,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/component-previews/body-conmponents/map-and-contact-black-all.png'),
            primary: true
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/map-and-contact-black-mazda.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Map and Contact Black",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: true
      },
      {
        type: "contact",
        id: 135,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/component-previews/body-conmponents/map-and-contact-white-all.png'),
            primary: true
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/map-and-contact-white-mazda.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Map and Contact White",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: true
      },
      {
        type: "content",
        id: 136,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/component-previews/body-conmponents/multi-reviews-carousel-all.png'),
            primary: true
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/multi-reviews-carousel-mazda.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Multiple Reviews Carousel",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: false
      },
      // {
      //   type: ["vehicles"],
      //   id: 137,
      //   previews: [
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/nav-vehicle-models-homepage.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehicle-models-homepage-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehicle-models-homepage-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehcile-models-homepage-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehicle-models-homepage-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehicle-models-homepage-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehcile-models-homepage-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehicle-models-homepage-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehicle-models-homepage-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/nav-vehicle-models-homepage-mitsu.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Nav Vehicle Models Homepage",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti", "Ford", "CJDR"],
      //   newer: false
      // },
      // {
      //   type: ["vehicles"],
      //   id: 138,
      //   previews: [
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/one-line-vehicle-row-kia.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/one-line-vehicle-row-mitsu.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "One Line Vehicle Row",
      //   description: "This component scrolls to the right to show all vehicles.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["content"],
      //   id: 139,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/preowned-brand-logos.png'),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Pre-Owned Brand Logos",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["quicklinks"],
      //   id: 140,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-all.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-cjdr.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/quicklink-tiles-mitsu.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Quicklink Tiles",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Infiniti"],
      //   newer: false
      // },
      {
        type: ["services"],
        id: 141,
        previews: [
          {
            brands: ["None", "Toyota", "Mitsubishi", "CJDR"],
            image: require('../static/images/schedule-service-bar.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/schedule-service-bar-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford", "Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/schedule-service-bar-navy.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/schedule-service-bar-honda.png'),
            primary: false
          },
          {
            brands: ["Infiniti", "Kia", "Mazda"],
            image: require('../static/images/component-previews/body-conmponents/schedule-service-bar-black.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/schedul-service-bar-lincoln.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/schedule-service-bar-nissan.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Schedule Service Bar",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      // {
      //   type: ["contact"],
      //   id: 142,
      //   previews: [
      //     {
      //       brands: ["None", "Toyota", "Nissan", "Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/search-by-zip-red.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/search-by-zip-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford", "Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/search-by-zip-navy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/search-by-zip-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/search-by-zip-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln", "CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/search-by-zip-lincoln.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Search by Zip",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["hero"],
        id: 143,
        previews: [
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-hyundai.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-honda.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-mazda.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-nissan.png'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/search-hero-overflow-toyota.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Search Hero with Overflow",
        description: "This component is able to use either an image or video background. The headline content is optional and customizable.",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: true
      },
      {
        type: ["services"],
        id: 144,
        previews: [
          {
            brands: ["Toyota", "Nissan", "Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/service-options-swoop-red.jpg'),
            primary: true
          },
          {
            brands: ["Infiniti", "Kia", "Mazda", "Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/service-options-swoop-black.jpg'),
            primary: false
          },
          {
            brands: ["Ford", "Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/service-options-swoop-navy.jpg'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/service-options-swoop-chevy.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/service-options-swoop-honda.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/service-options-swoop-cjdr.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Service Options with Swoop",
        description: "This component has content that moves onto the page with scroll.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["services"],
        id: 145,
        previews: [
          {
            brands: ["Toyota", "Nissan", "Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-display-parallax-red.png'),
            primary: true
          },
          {
            brands: ["Infiniti", "Kia", "Mazda", "Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-display-parallax-black.png'),
            primary: false
          },
          {
            brands: ["Ford", "Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-display-parallax-navy.png'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-display-parallax-chevy.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-display-parallax-honda.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-display-parallax-cjdr.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Service Parts Display with Parallax",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["services"],
        id: 146,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/services-offered-display.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Services Offered Display",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["content"],
        id: 147,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-toyota.png'),
            primary: true
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-hyundai.png'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-honda.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-mazda.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-nissan.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/seo-content-collapsible-cjdr.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "SEO Content Collapsible",
        description: "Our SEO team will write custom content to increase your relevance in seearch results as well as inform visitors more about your dealership.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["content"],
        id: 148,
        previews: [
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/mazda-seo-content-collapsible-01.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "SEO Content Collapsible Mazda",
        description: "",
        exclusive: ["None", "Mazda"],
        packages: [],
        exclude_from: [],
        newer: true
      },
      {
        type: ["content"],
        id: 170,
        previews: [
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-over-image-showcase.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Homepage Content Over Image Showcase",
        description: "",
        exclusive: ["Infiniti"],
        packages: [],
        exclude_from: [],
        newer: true
      },
      {
        type: ["filter"],
        id: 149,
        previews: [
          {
            brands: ["None", "Toyota", "Mitsubishi"],
            image: require('../static/images/shop-and-service-filter.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/shop-service-filter-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford", "Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/shop-and-service-filter-navy.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/shop-service-filter-honda.png'),
            primary: false
          },
          {
            brands: ["Infiniti", "Kia", "Mazda"],
            image: require('../static/images/component-previews/body-conmponents/shop-service-filter-black.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/shop-service-filter-lincoln.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/shop-service-filter-nissan.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/shop-service-filter-cjdr.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Shop and Service Filter",
        description: "This component has a filter along with call-to-action buttons for shopping on one tab and service hours and call-to-action buttons for service on the other.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      },
      {
        type: ["filter"],
        id: 150,
        previews: [
          {
            brands: ["None", "Toyota"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-toyota.jpg'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-chevy.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-ford.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-honda.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-infiniti.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-kia.jpg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-mitsu.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/service-and-shop-filter-cjdr.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Shop and Service Filter Service First",
        description: "This component shows an alternative look and emphasis for the Shop and Service Filter. It has service hours and call-to-action buttons for service on one tab and a filter along with call-to-action buttons for shopping on the other.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      },
      // {
      //   type: ["filter"],
      //   id: 151,
      //   previews: [
      //     {
      //       brands: ["None", "Toyota", "Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-style-filter-red.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-by-style-filter-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford", "Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-by-style-filter-navy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-by-style-filter-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti", "Kia", "Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-by-style-filter-black.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-by-style-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-style-filter-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/shop-by-style-filter-cjdr.png'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Shop by Style Filter",
      //   description: "This component allows the user to narrow their search by body style and price.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["contact"],
        id: 152,
        previews: [
          {
            brands: ["None", "Toyota", "Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-red.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti", "Kia", "Mazda"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-black.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-lincoln.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-nissan.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/social-media-color-blocks-cjdr.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Social Media Color Blocks",
        description: "The color blocks shown here change color on hover to match their social media platform's colors.",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: false
      },
      // {
      //   type: ["contact"],
      //   id: 153,
      //   previews: [
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-nissan.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/social-media-display-cjdr.jpg'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Social Media Display",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["hero"],
        id: 154,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/specials-multislider.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/specials-multislider-ford-2025.png'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-mazda.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-nissan.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/specials-multislider-mitsu.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Specials Multislider",
        description: "This component accepts different background images, car images, and displays any verbiage or deal you want to highlight. The box containing the information and link swoops down from the top and the car image swoops in from the right, offering a unique and exciting look. The component is a carousel that can cycle through multiple slides.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      }, 
      {
        type: ["hero"],
        id: 155,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/specials-multislider-6040--default.jpg'),
            primary: true
          }, 
          {
            brands: ["Chevrolet"],
            image: require('../static/images/specials-multislider-6040--chevrolet.jpeg'),
            primary: true
          }, 
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/specials-slider-6040-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/specials-multislider-6040--ford.jpeg'),
            primary: true
          }, 
          {
            brands: ["Honda"],
            image: require('../static/images/specials-multislider-6040--honda.jpeg'),
            primary: true
          }, 
          {
            brands: ["Hyundai"],
            image: require('../static/images/specials-multislider-6040--hyundai.jpeg'),
            primary: true
          }, 
          {
            brands: ["Infiniti"],
            image: require('../static/images/specials-multislider-6040--infiniti.png'),
            primary: true
          }, 
          {
            brands: ["Kia"],
            image: require('../static/images/specials-multislider-6040--kia.jpeg'),
            primary: true
          }, 
          {
            brands: ["Lincoln"],
            image: require('../static/images/specials-multislider-6040--lincoln.jpeg'),
            primary: true
          }, 
          {
            brands: ["Mazda"],
            image: require('../static/images/specials-multislider-6040--mazda.jpeg'),
            primary: true
          }, 
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/specials-multislider-6040--mitsubishi.jpeg'),
            primary: true
          }, 
          {
            brands: ["Nissan"],
            image: require('../static/images/specials-multislider-6040--nissan.jpeg'),
            primary: true
          }, 
          {
            brands: ["Toyota"],
            image: require('../static/images/specials-multislider-6040--toyota.jpeg'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Specials Slider 6040",
        description: "This component slides through specials or any vehicles, service, etc topics you may want to highlight. Images, text, disclaimer, and button are all customizable.",
        exclusive: [],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: false
      }, 
      {
        type: ["filter"],
        id: 156,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-default.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-dark-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-mazda.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-nissan.png'),
            primary: false
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-toyota.png'),
            primary: false
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Tabbed Search Filter",
        description: "This component offers the ability to filter inventory by: Total Price, Monthly Payment, Make, or Model. As you adjust the search criteria, a 'View Results' button appears with a count to reflect the number of matches.",
        exclusive: [],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["vehicles"],
        id: 157,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/tabbed-vehicle-rows-toyota.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/tabbed-vehicle-rows-ford.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-cjdr.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-mazda.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-nissan.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-mitsu.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Tabbed Vehicle Rows",
        description: "This component is a carousel that cycles through different vehicles depending on the tab selected.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      },
      {
        type: ["vehicles"],
        id: 158,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-toyota.jpg'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('..//static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-ford.jpg'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-chevy.jpg'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-cjdr.jpg'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-honda.jpg'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-hyundai.jpg'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-infiniti.jpg'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-kia.jpg'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-lincoln.jpg'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-nissan.jpg'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-content-mitsu.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Tabbed Vehicle Rows with Content",
        description: "This component is a carousel that cycles through different vehicles depending on the tab selected.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["vehicles"],
        id: 159,
        previews: [
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-mazda.png'),
            primary: true
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-toyota.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-ford.png'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-chevrolet.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-vehicle-rows-side-cjdr.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-lincoln.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-nissan.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/tab-vehicle-row-side-mitsubishi.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Tabbed Vehicle Rows Side View",
        description: "This component is a carousel that cycles through different vehicles depending on the tab selected.",
        exclusive: [],
        packages: [],
        exclude_from: ["Infiniti"],
        newer: true
      },
      {
        type: ["services"],
        id: 160,
        previews: [
          {
            brands: ["Toyota", "Nissan", "Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/trade-service-parts-display-red.png'),
            primary: true
          },
          {
            brands: ["Infiniti", "Kia", "Mazda", "Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/trade-service-parts-display-black.png'),
            primary: false
          },
          {
            brands: ["Ford", "Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/trade-service-parts-display-navy.png'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/trade-service-parts-display-chevy.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/trade-service-parts-display-honda.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/trade-service-parts-display-cjdr.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Trade Service Parts Display",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      {
        type: ["quicklinks"],
        id: 161,
        previews: [
          {
            brands: ["None"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-default.png'),
            primary: true
          },
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-toyota.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-ford.png'),
            primary: false
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-cjdr.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-lincoln.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-nissan.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/value-blocks-slider-mitsu.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Value Blocks Slider",
        description: "This component takes custom images and inputs for header, subheader, button, and an optional Terms & Conditions link with modal. It allows the user to scroll horizontally through options so as not to take up too much vertical space on the page.",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["vehicles"],
        id: 162,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/vehicle-options-black.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-chevy.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-mazda.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-nissan.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-mitsu.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/vehicle-options-black-cjdr.jpg'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Vehicle Options Black",
        description: "",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: false
      },
      // {
      //   type: ["vehicles"],
      //   id: 163,
      //   previews: [
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/vehicle-options-browse-white.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-nissan.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-options-white-cjdr.jpg'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Vehicle Options Browse White",
      //   description: "",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      // {
      //   type: ["vehicles"],
      //   id: 164,
      //   previews: [
      //     {
      //       brands: ["Nissan"],
      //       image: require('../static/images/vehicle-slides-with-backdrop.png'),
      //       primary: true
      //     },
      //     {
      //       brands: ["Chevrolet"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-with-backdrop-chevy.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Ford"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-with-backdrop-ford.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Honda"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-backdrop-honda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Hyundai"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-with-backdrop-hyundai.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Infiniti"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-with-backdrop-infiniti.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Kia"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-with-backdrop-kia.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Lincoln"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-backdrop-lincoln.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mazda"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-with-backdrop-mazda.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Toyota"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-backdrop-toyota.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["Mitsubishi"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-backdrop-mitsu.png'),
      //       primary: false
      //     },
      //     {
      //       brands: ["CJDR"],
      //       image: require('../static/images/component-previews/body-conmponents/vehicle-slides-backdrop-cjdr.jpg'),
      //       primary: false
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Vehicle Slides with Backdrop",
      //   description: "This component slides car images in and out of frame depending on which vehicle tab is selected.",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: ["vehicles"],
        id: 169,
        previews: [
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/brand-models-slider.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Brand Models Slider",
        description: "This component slides car images in and out of frame depending on which vehicle tab is selected.",
        exclusive: ["Infiniti"],
        packages: [],
        exclude_from: [],
        newer: false
      },
      {
        type: ["filter"],
        id: 171,
        previews: [
          {
            brands: ["None", "Chevrolet", "CJDR", "Ford", "Honda", "Hyundai", "Lincoln", "Mitsubishi", "Nissan", "Toyota"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-v-search-bar-light.png'),
            primary: true
          },
          {
            brands: ["Infiniti", "Kia"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-v-search-bar-dark.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Tabbed Search Filter V Search Bar",
        description: "This component offers the ability to filter inventory by: Total Price, Monthly Payment, Make, or Model. As you adjust the search criteria, a 'View Results' button appears with a count to reflect the number of matches.",
        exclusive: [],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["filter"],
        id: 172,
        previews: [
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/luxury-tabbed-search-filter-infiniti.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Luxury Tabbed Search Filter",
        description: "This component offers the ability to filter inventory by: Total Price, Monthly Payment, Make, or Model. As you adjust the search criteria, a 'View Results' button appears with a count to reflect the number of matches.",
        exclusive: ["Infiniti"],
        packages: [],
        exclude_from: [],
        newer: true,
        priority: 0
      },
      {
        type: ["quicklinks"],
        id: 173,
        previews: [
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/luxury-homepage-quick-links-infiniti.png'),
            primary: false
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Luxury Homepage Quick Links",
        description: "",
        exclusive: ["Infiniti"],
        packages: [],
        exclude_from: ["Mazda"],
        newer: true,
        priority: 0
      },
      {
        type: ["content"],
        id: 174,
        previews: [
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/body-conmponents/luxury-homepage-content-overlay-infiniti.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Luxury Homepage Content Overlay",
        description: "",
        exclusive: ["Infiniti"],
        packages: [],
        exclude_from: [],
        newer: true,
        priority: 0
      },
      {
        type: ["hero"],
        id: 175,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-v2-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/background-video-slider-v2-default.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Background Video Slider v2",
        description: "This component can show multiple carousel slides with different image or video backgrounds, different text, and different CTA buttons. The slideshow functionality will disappear if you only want one slide or are waiting to add more slides as new offers at your dealership become available, etc.",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["quicklinks"],
        id: 176,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-with-search-v-luxury-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/interaction-bar-with-search-v-luxury-ford.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Interaction Bar with Search v Luxury",
        description: "A row of icons where each one links out to a popular page on the website. Can be scrolled horizontally via navigational arrows (desktop) or by swiping (mobile).",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["vehicles"],
        id: 177,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/brand-popular-models-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/brand-popular-models-ford.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Brand Popular Models",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["filter"],
        id: 178,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-v-search-bar-luxury-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/tabbed-search-filter-v-search-bar-luxury.png'),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Tabbed Search Filter V Search Bar Luxury",
        description: "This component offers the ability to filter inventory by: Total Price, Monthly Payment, Make, or Model. As you adjust the search criteria, a 'View Results' button appears with a count to reflect the number of matches.",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["content"],
        id: 179,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/dealer-name-marquee-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/dealer-name-marquee.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Dealer Name Marquee",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["content"],
        id: 180,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/video-cards-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/video-cards.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Video Cards",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["content"],
        id: 181,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/shopping-tools-tiles-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/shopping-tools-tiles.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Shopping Tools Tiles",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["banner"],
        id: 182,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/highlight-banner-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/highlight-banner.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Highlight Banner",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["content"],
        id: 183,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-over-image-side-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/homepage-content-over-image-side.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Homepage Content Over Image Side",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["content"],
        id: 184,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/seo-accordion-content-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/seo-accordion-content.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Seo Content Accordion",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["services"],
        id: 185,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-grid-tiles-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/service-parts-grid-tiles.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Service Parts Grid Tiles",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["contact"],
        id: 186,
        previews: [
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/map-and-contact-slim.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Map and Contact Slim",
        description: "",
        exclusive: ["Ford"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["hero"],
        id: 187,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/specials-slider-v-luxury-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/specials-slider-v-luxury.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Specials Slider v Luxury",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },

    ],
    footerComponents: [
      // {
      //   type: 'footer',
      //   id: 900,
      //   previews: [
      //     {
      //       brands: ["None"],
      //       image: require("../static/images/footer.png"),
      //       primary: true
      //     }
      //   ],
      //   mobilePreview: "",
      //   body: "",
      //   title: "Default Footer",
      //   exclusive: [],
      //   packages: [],
      //   exclude_from: ["Mazda", "Infiniti"],
      //   newer: false
      // },
      {
        type: 'footer',
        id: 901,
        previews: [
          {
            brands: ["None"],
            image: require("../static/images/component-previews/footer-left-preview.png"),
            primary: true
          },
          {
            brands: ["Infiniti"],
            image: require("../static/images/component-previews/footer-components/footer-left-preview-infiniti.png"),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Footer Gray Left",
        exclusive: [],
        packages: [],
        exclude_from: [],
        newer: true
      },
      {
        type: 'footer',
        id: 902,
        previews: [
          {
            brands: ["None"],
            image: require("../static/images/component-previews/footer-white-left.png"),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Footer White Left",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda", "Infiniti"],
        newer: true
      },
      {
        type: 'pre-foot',
        id: 903,
        previews: [
          {
            brands: ["None", "Nissan", "Toyota"],
            image: require("../static/images/component-previews/footer-components/footer-contact-icon-row-dark-toyota.png"),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/footer-components/footer-contact-icon-row-dark-mitsu.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Footer Contact Icon Row Dark",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: 'pre-foot',
        id: 904,
        previews: [
          {
            brands: ["None", "Chevrolet", "CJDR", "Hyundai", "Kia", "Toyota"],
            image: require("../static/images/component-previews/footer-components/footer-icon-row-light-toyota.png"),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/footer-components/footer-icon-row-light-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/footer-components/footer-icon-row-light-honda.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/footer-components/footer-icon-row-light-infiniti.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/footer-components/footer-icon-row-light-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/footer-components/footer-icon-row-light-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/footer-components/footer-icon-row-light-nissan.png'),
            primary: false
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Footer Contact Icon Row Light",
        exclusive: [],
        packages: [],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: 'pre-foot',
        id: 905,
        previews: [
          {
            brands: ["CJDR"],
            image: require("../static/images/component-previews/footer-components/solid-background-map-hours-cjdr.png"),
            primary: true
          },
          {
            brands: ["Infiniti"],
            image: require("../static/images/component-previews/footer-components/solid-background-map-hours-dark.png"),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Solid Background Map and Hours Dark",
        description: "",
        exclusive: ["Infiniti", "CJDR"],
        packages: [],
        exclude_from: [],
        newer: true
      },
      {
        type: 'pre-foot',
        id: 906,
        previews: [
          {
            brands: ["Infiniti"],
            image: require("../static/images/component-previews/footer-components/solid-background-map-hours-light.png"),
            primary: true
          }
        ],
        mobilePreview: "",
        body: "",
        title: "Solid Background Map and Hours Light",
        description: "",
        exclusive: ["Infiniti"],
        packages: [],
        exclude_from: [],
        newer: true
      },
      {
        type: ["pre-foot"],
        id: 907,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/dealer-name-marquee-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/dealer-name-marquee.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Dealer Name Marquee Footer",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
      {
        type: ["footer"],
        id: 908,
        previews: [
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/body-conmponents/footer-left-ctas-cjdr.png'),
            primary: true
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/body-conmponents/footer-left-ctas.png'),
            primary: true
          },
        ],
        mobilePreview: "",
        body: "",
        title: "Footer Left Ctas",
        description: "",
        exclusive: ["Ford", "CJDR"],
        packages: ["Ultimate"],
        exclude_from: ["Mazda"],
        newer: true
      },
    ],
    srpComponents: [
      {
        type: 'srp',
        id: 1001,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/srp-components/srp-grid-toyota.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/srp-components/grid-srp-preview-nissan.png'),
            primary: false
          }
        ],
        mobilePreview: null,
        body: "",
        title: "Grid based Search Results",
        description: "",
        exclusive: []
      },
      {
        type: 'srp',
        id: 1002,
        previews: [
          {
            brands: ["Toyota"],
            image: require('../static/images/component-previews/srp-components/srp-rows-toyota.png'),
            primary: true
          },
          {
            brands: ["Chevrolet"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-chevy.png'),
            primary: false
          },
          {
            brands: ["CJDR"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-cjdr.png'),
            primary: false
          },
          {
            brands: ["Ford"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-ford.png'),
            primary: false
          },
          {
            brands: ["Honda"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-honda.png'),
            primary: false
          },
          {
            brands: ["Hyundai"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-hyundai.png'),
            primary: false
          },
          {
            brands: ["Infiniti"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-infiniti.png'),
            primary: false
          },
          {
            brands: ["Kia"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-kia.png'),
            primary: false
          },
          {
            brands: ["Lincoln"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-lincoln.png'),
            primary: false
          },
          {
            brands: ["Mitsubishi"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-mitsu.png'),
            primary: false
          },
          {
            brands: ["Nissan"],
            image: require('../static/images/component-previews/srp-components/row-srp-preview-nissan.png'),
            primary: false
          },
        ],
        mobilePreview: null,
        body: "",
        title: "Row based Search Results",
        description: "",
        exclusive: []
      },
      {
        type: 'srp',
        id: 1003,
        previews: [
          {
            brands: ["Mazda"],
            image: require('../static/images/component-previews/srp-components/mazda-approved-srp-preview.png'),
            primary: true
          },
        ],
        mobilePreview: null,
        body: "",
        title: "Mazda Approved Search Results",
        description: "",
        exclusive: ["Mazda"]
      }
    ],
    pricingComponents: [
      {
        type: 'pricing',
        id: 1101,
        preview: require('../static/images/locked_pricing.png'),
        title: 'Locked Pricing',
        exclusive: []
      },
      {
        type: 'pricing',
        id: 1102,
        preview: require('../static/images/unlocked_pricing.png'),
        title: 'Unlocked Pricing',
        exclusive: []
      }
    ],
    buttonComponents: {
      unlockedPricing: [
        {
          type: 'get-price-btn',
          id: 1200,
          previews: [
            {
              brands: ['Toyota'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-toyota.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-toyota.png'),
              primary: true,
            },
            {
              brands: ['Chevrolet'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-chevy.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-chevy.png'),
              primary: false,
            },
            {
              brands: ['CJDR'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-cjdr.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-cjdr.png'),
              primary: false,
            },
            {
              brands: ['Ford'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-ford.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-ford.png'),
              primary: false,
            },
            {
              brands: ['Honda'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-honda.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-honda.png'),
              primary: false,
            },
            {
              brands: ['Hyundai'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-hyundai.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-hyundai.png'),
              primary: false,
            },
            {
              brands: ['Infiniti'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-infiniti.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-infiniti.png'),
              primary: false,
            },
            {
              brands: ['Kia'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-kia.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-kia.png'),
              primary: false,
            },
            {
              brands: ['Lincoln'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-lincoln.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-lincoln.png'),
              primary: false,
            },
            {
              brands: ['Mitsubishi'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-mitsu.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-mitsu.png'),
              primary: false,
            },
            {
              brands: ['Nissan'],
              image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-nissan.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-eprice-button-nissan.png'),
              primary: false,
            }
          ],
          title: 'Brand Specific HTML Button',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1201,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/eprice-button.png'),
              hovered_image: require('../static/images/srp-buttons/eprice-button.png'),
              primary: true,
            }
          ],
          title: 'Click for Lowest Price Green',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1202,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/eprice-button-secondary.png'),
              hovered_image: require('../static/images/srp-buttons/eprice-button-secondary-hovered.png'),
              primary: true,
            }
          ],
          title: 'Lock in this Price Red with Pressed Green Hover',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1203,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/additional-savings-button.png'),
              hovered_image: require('../static/images/srp-buttons/additional-savings-button.png'),
              primary: true,
            }
          ],
          title: 'Get Additional Savings Green',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1204,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/eprice-green-rectangle-grid-button.gif'),
              primary: true,
            }
          ],
          title: 'Click Here for Eprice Green Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1205,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/schedule-test-drive-button.png'),
              primary: true,
            }
          ],
          title: 'Schedule Test Drive Green',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1206,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/additional-savings-grid-button.gif'),
              primary: true,
            }
          ],
          title: 'Additional Savings Button Rainbow Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1207,
          previews: [
            {
              brands: ['chevrolet'],
              image: require('../static/images/srp-buttons/additional-savings-grid-chevrolet-button.gif'),
              primary: true,
            },
            {
              brands: ['mazda'],
              image: require('../static/images/srp-buttons/additional-savings-mazda-gif.gif'),
              primary: false,
            },
          ],
          title: 'Additional Savings Button Black Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1208,
          previews: [
            {
              brands: ['none', 'toyota', 'mitsubishi'],
              image: require('../static/images/srp-buttons/additional-savings-grid-toyota-button.gif'),
              primary: true,
            }
          ],
          title: 'Additional Savings Red Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1209,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/additional-savings-red-round-gif.gif'),
              primary: true,
            }
          ],
          title: 'Additional Savings Round Red Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1210,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/additional-savings-bounce-red.gif'),
              primary: true,
            }
          ],
          title: 'Additional Savings Red Button Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1211,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/check-availability-red-gif-01.gif'),
              primary: true,
            }
          ],
          title: 'Check Availability Red Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1212,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/eprice-button-red-02.png'),
              hovered_image: require('../static/images/srp-buttons/eprice-button-red-02hover.png'),
              primary: true,
            }
          ],
          title: 'Click Here for your Eprice Red with Pressed Green Hover',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1213,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/eprice-red-round-01.png'),
              hovered_image: require('../static/images/srp-buttons/eprice-red-round-01hover.png'),
              primary: true,
            }
          ],
          title: "Click Here to Get Today's Best Price Red with Green Hover",
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1214,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/eprice-red-round-02.png'),
              hovered_image: require('../static/images/srp-buttons/eprice-red-round-02.png'),
              primary: true,
            }
          ],
          title: "Get Your Best Price Red",
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1215,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/unlock-red-rectangle-flat.png'),
              hovered_image: require('../static/images/srp-buttons/unlock-red-rectangle-flat.png'),
              primary: true,
            }
          ],
          title: "Click to Unlock Additional Savings Red",
          srp_types: ['row', 'grid'],
          exclusive: []
        },
      ],
      lockedPricing: [
        {
          type: 'get-price-btn',
          id: 1300,
          previews: [
            {
              brands: ['Toyota'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-toyota.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-toyota.png'),
              primary: true,
            },
            {
              brands: ['Chevrolet'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-chevy.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-chevy.png'),
              primary: false,
            },
            {
              brands: ['CJDR'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-cjdr.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-cjdr.png'),
              primary: false,
            },
            {
              brands: ['Ford'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-ford.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-ford.png'),
              primary: false,
            },
            {
              brands: ['Honda'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-honda.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-honda.png'),
              primary: false,
            },
            {
              brands: ['Hyundai'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-hyundai.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-hyundai.png'),
              primary: false,
            },
            {
              brands: ['Infiniti'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-infiniti.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-infiniti.png'),
              primary: false,
            },
            {
              brands: ['Kia'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-kia.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-kia.png'),
              primary: false,
            },
            {
              brands: ['Lincoln'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-lincoln.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-lincoln.png'),
              primary: false,
            },
            {
              brands: ['Mitsubishi'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-mitsu.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-mitsu.png'),
              primary: false,
            },
            {
              brands: ['Nissan'],
              image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-nissan.png'),
              hovered_image: require('../static/images/srp-buttons/html-buttons/flat-unlock-button-nissan.png'),
              primary: false,
            }
          ],
          title: 'Brand Specific HTML Button',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1301,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/unlock-button.png'),
              hovered_image: require('../static/images/srp-buttons/unlock-button-hovered.png'),
              primary: true,
            },
            {
              brands: ['infiniti', 'kia', 'lincoln'],
              image: require('../static/images/srp-buttons/unlock-button-infiniti.png'),
              hovered_image: require('../static/images/srp-buttons/unlock-button-infiniti-hovered.png'),
              primary: false,
            },
            {
              brands: ['mazda'],
              image: require('../static/images/srp-buttons/unlock-button-mazda-black-01.png'),
              hovered_image: require('../static/images/srp-buttons/unlock-button-mazda-black-01hover.png'),
              primary: false,
            }
          ],
          title: 'Click to Unlock Price with Pressed Hover',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1302,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/unlock-button-red-01.png'),
              hovered_image: require('../static/images/srp-buttons/unlock-button-red-01hover.png'),
              primary: true,
            },
          ],
          title: 'Unlock Price Red with Pressed Green Hover',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1303,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/click-to-unlock-button.gif'),
              primary: true,
            },
          ],
          title: 'Click to Unlock Rainbow Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1305,
          previews: [
            {
              brands: ['none', 'toyota', 'mitsubishi'],
              image: require('../static/images/srp-buttons/click-to-unlock-toyota-button.gif'),
              primary: true,
            },
            {
              brands: ['nissan'],
              image: require('../static/images/srp-buttons/click-to-unlock-nissan-button.gif'),
              primary: false,
            }
          ],
          title: 'Click to Unlock Red Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1306,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/unlock-black-flat-01.png'),
              hovered_image: require('../static/images/srp-buttons/unlock-black-flat-01hover.png'),
              primary: true,
            },
          ],
          title: 'Click to Unlock Price Black with Red Outline on Hover',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1307,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/click-for-price-grid-button.gif'),
              primary: true,
            },
            {
              brands: ['infiniti', 'mazda', 'kia', 'lincoln'],
              image: require('../static/images/srp-buttons/click-for-price-infiniti-grid-button.gif'),
              primary: false,
            },
            {
              brands: ['ford', 'honda'],
              image: require('../static/images/srp-buttons/click-for-price-ford-grid-button.gif'),
              primary: false,
            }
          ],
          title: 'Click for Price Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1308,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/unlock-blue-lock-gif.gif'),
              primary: true,
            },
          ],
          title: 'Click to Unlock Price Locking Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1309,
          previews: [
            {
              brands: ['None'],
              image: require('../static/images/srp-buttons/reveal-deal-unlock-neutral-gif.gif'),
              primary: true,
            },
            {
              brands: ['toyota', 'mitsubishi', 'nissan'],
              image: require('../static/images/srp-buttons/reveal-deal-unlock-red-gif-01.gif'),
              primary: false,
            },
            {
              brands: ['ford', 'hyundai'],
              image: require('../static/images/srp-buttons/reveal-deal-unlock-blue-black-gif.gif'),
              primary: false,
            }
          ],
          title: 'Reveal the Deal Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1310,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/unlock-slide-blue-green-gif.gif'),
              primary: true,
            },
          ],
          title: 'Slide to Unlock Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1311,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/unlock-black-rectangle-gif.gif'),
              primary: true,
            },
            {
              brands: ['ford', 'hyundai'],
              image: require('../static/images/srp-buttons/unlock-blue-rectangle-gif.gif'),
              primary: false,
            }
          ],
          title: 'Unlock Price Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        {
          type: 'get-price-btn',
          id: 1312,
          previews: [
            {
              brands: ['none'],
              image: require('../static/images/srp-buttons/unlock-multicolor-round-gif.gif'),
              primary: true,
            },
          ],
          title: 'Click to Unlock the Price Rainbow Gif',
          srp_types: ['row', 'grid'],
          exclusive: []
        },
        
      ]
    }
  },
  getters: {
    chosenArray: state => state.chosenComponents,
    imagePreview: (state) => (component) => {
      const { preview, previews } = component
      if (preview && preview.length) return preview
  
      const brandedImg = previews.find(function(p) {
        for (var i = 0; i < p.brands.length; i++) {
          if (p.brands[i].toLowerCase() === state.chosenBrand.toLowerCase()) {
            return p
          }
        }
      })

      const defaultImg = previews.find(p =>
        p.primary === true
      )

      var chosenBrand = state.chosenBrand.toLowerCase();

      if (chosenBrand !== 'none' && brandedImg) {
        return brandedImg.image
      } else {
        return defaultImg.image
      }
    },
    brandData: (state) => {
      var brands = state.brands;
      var chosenBrand = state.chosenBrand;
      return chosenBrand !== 'none' && chosenBrand in brands ? brands[chosenBrand] : brands['brandDefault'];
    },
    selectedBrandVehicles: (state, getters, _) => {
      const {
        brandData: {
          images: {
            trucks = [],
            suvs = [],
            sedans = [],
            evs = []
          } = {}
        } = {}
      } = getters

      return [...trucks, ...suvs, ...sedans, ...evs]
    }
  },
  mutations: {
    updateList: (state, value) => {
      state.columns = value;
    },

    chooseBrand: (state, value) => {
      state.chosenBrand = value
    }
  },
  actions: {
    updateList: ({ commit }, list) => {
      commit('updateList', list)
    },

    chooseBrand: ({ commit }, chosenBrand) => {
      commit('chooseBrand', chosenBrand)
    }
  }
});